import React, { useEffect, useState } from "react"
import KnowmixStep from "./knowmixStep/knowmixStep"
import { useLocation } from "react-router-dom"
import * as qs from "query-string"
import Loader from "../../../../../components/ui/loader"

const KnowmixSteps = ({
  steps,
  startKnowmix,
  knowmixFinished,
  canTakeQuiz = true,
}) => {
  const location = useLocation()
  const [activeStep, setActiveStep] = useState(
    steps.length ? steps[0].id : null
  )
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const { stepId } = qs.parse(location.search)
    if (stepId) setActiveStep(parseInt(stepId, 10))
    setIsLoading(false)
  }, [])

  return !isLoading ? (
    <div className="box">
      <div className="box__content">
        {!!steps.length ? (
          <>
            <p className="box__subheading">Course program</p>
            {steps.map((item, i) => (
              <KnowmixStep
                isActive={item.id === activeStep}
                startKnowmix={startKnowmix}
                knowmixFinished={knowmixFinished}
                step={item}
                stepNumber={i + 1}
                key={item.id}
                canTakeQuiz={canTakeQuiz}
              />
            ))}
          </>
        ) : (
          <p className="color-black-54 text-center">
            Course doesn't have program yet
          </p>
        )}
      </div>
    </div>
  ) : (
    <Loader />
  )
}

export default KnowmixSteps
